import { useTranslation } from "react-i18next";
import { Controller, useFormContext } from "react-hook-form";
import { Box, Checkbox, FormControl, FormLabel, TextField } from "@mui/material";

import { EntityBranchFormData } from "../../../Entity/types/entityBranch.types";

const BasicInfoTab = ({ isBranchDataLoading }: { isBranchDataLoading: boolean }) => {
  const { t } = useTranslation("profiles", { keyPrefix: "entityProfileEditBranch" });
  const { control } = useFormContext<EntityBranchFormData>();

  return (
    <Box sx={styles.container}>
      <Controller
        name="name"
        control={control}
        render={({ field, fieldState: { error } }) => (
          <FormControl error={!!error} fullWidth>
            <FormLabel>{t("branchName")}</FormLabel>
            <TextField
              {...field}
              error={!!error}
              helperText={error?.message && t(error.message)}
              placeholder={t("branchNameExample")}
              disabled={isBranchDataLoading}
            />
          </FormControl>
        )}
      />
      <Controller
        name="address"
        control={control}
        render={({ field, fieldState: { error } }) => (
          <FormControl error={!!error} fullWidth>
            <FormLabel>{t("address")}</FormLabel>
            <TextField
              {...field}
              error={!!error}
              helperText={error?.message && t(error.message)}
              placeholder={t("fullAddress")}
              disabled={isBranchDataLoading}
            />
          </FormControl>
        )}
      />
      <Controller
        name="googleMapsLink"
        control={control}
        render={({ field, fieldState: { error } }) => (
          <FormControl error={!!error} fullWidth>
            <FormLabel>{t("googleMapLink")}</FormLabel>
            <TextField
              {...field}
              error={!!error}
              helperText={error?.message && t(error.message)}
              placeholder={t("enterGoogleMapLink")}
              disabled={isBranchDataLoading}
            />
          </FormControl>
        )}
      />
      <Controller
        name="isHeadquarter"
        control={control}
        render={({ field, fieldState: { error } }) => (
          <FormControl error={!!error} fullWidth sx={styles.checkboxContainer}>
            <Checkbox
              size="small"
              checked={field.value}
              onChange={(e) => field.onChange(e.target.checked)}
              disabled={isBranchDataLoading}
            />
            <FormLabel>{t("headquarters")}</FormLabel>
          </FormControl>
        )}
      />
    </Box>
  );
};

export default BasicInfoTab;

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    padding: "0 16px",
    gap: "16px",
  },
  checkboxContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "center",
    gap: "8px",
  },
};
